import { Typography } from "@material-ui/core";
import React from "react";

export default function LangSwitch({
  switchTextWhenOn,
  switchTextWhenOff,
  switchWidth = 75,
  switchValue,
  switchState = false,
}) {
  const [on, setOn] = React.useState(switchState === "en" ? true : false);
  React.useEffect(() => {
    switchValue(on);
  }, [on]);
  const container = {
    width: switchWidth,
    height: 36,
    borderRadius: 32,
    position: "relative",
    cursor: "pointer",
    direction: "ltr",
    WebkitTapHighlightColor: "transparent",
    outline: "none",
  };

  const ellipseOn = {
    width: 30,
    height: 30,
    borderRadius: "50%",
    position: "relative",
    top: 3,
    background: `#004E5E`,
    transition: "left 0.2s",
  };

  const text = {
    // fontSize: 14,
    // fontWeight: 400,

    position: "absolute",
    color: "#004E5E",
    top: 7.5,
    transition: "left 0.2s",
    userSelect: "none",
  };
  const textOn = (
    <div>
      <span style={{ display: "inline-block" }}>{switchTextWhenOn} </span>
    </div>
  );
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        WebkitTapHighlightColor: "transparent",
        outline: "none",
      }}
    >
      <div
        style={{ ...container, background: on ? `#FFFFFF` : "#FFFFFF" }}
        onClick={() => {
          setOn((prev) => !prev);
        }}
      >
        <div style={{ ...ellipseOn, left: on ? 2 : switchWidth - 32 }}></div>
        <span
          style={{
            ...text,
            left: on ? 45 : 10,
            marginLeft: on ? "" : "8px",

            color: !on ? "#004E5E" : "#004E5E",
          }}
        >
          {" "}
          <Typography variant="body2" style={{ fontWeight: 700 }}>
            {on ? switchTextWhenOn : switchTextWhenOff}
          </Typography>
        </span>
      </div>
    </div>
  );
}
